const PLATFORM = {
  MOBILE: 'MOBILE',
  WEB: 'WEB',
};

export default PLATFORM;
